<script lang="ts" setup>
  interface Props {
    headingId?: string | number;
    headerType?: string;
    headingStyle?: boolean;
  }

  defineProps<Props>();
  const open = defineModel('open', { type: Boolean, required: false, default: false });
</script>

<template>
  <header class="drawer__header">
    <SfHeading v-if="$slots.default" :id="headingId" :type="headerType" headingStyle>
      <slot />
    </SfHeading>
    <SfButton :aria-label="$t('SHOP.COMMON.ACTION.CLOSE_DRAWER')" rounded square @click="open = false">
      <SfIconClose aria-hidden="true" />
    </SfButton>
  </header>
</template>

<style lang="scss">
  @use "@storefront/styles/mixins/media";

  :root {
    --sf-drawer-header-gap: 1rem;
    --sf-drawer-header-align-items: flex-start;
    --sf-drawer-header-font-family: var(--font-family-sans);
    --sf-drawer-header-color: var(--color-black);
    --sf-drawer-header-padding-y: 0;
    --sf-drawer-header-padding-x: 0;
    --sf-drawer-header-background: transparent;
  }

  .drawer__header {
    display: flex;
    justify-content: space-between;
    align-items: var(--sf-drawer-header-align-items);
    gap: var(--sf-drawer-header-gap);
    font-family: var(--sf-drawer-header-font-family);
    color: var(--sf-drawer-header-color);
    background-color: var(--sf-drawer-header-background);
    padding: var(--sf-drawer-header-padding-y) var(--sf-drawer-header-padding-x);
    border-radius: var(--ui-drawer-content-border-radius) var(--ui-drawer-content-border-radius) 0 0;
  }
</style>
